module.exports = __webpack_public_path__ + "img/product_93.76e1ec6.svg";